import { render, staticRenderFns } from "./PopupCalendar.vue?vue&type=template&id=5aaf011d&scoped=true"
import script from "./PopupCalendar.vue?vue&type=script&lang=ts"
export * from "./PopupCalendar.vue?vue&type=script&lang=ts"
import style0 from "./PopupCalendar.vue?vue&type=style&index=0&id=5aaf011d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf011d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VMenu})
